import { Box, Button, Flex, Link, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { useContext, useEffect } from 'react';
import { Link as ReactRouterLink, useLocation } from 'react-router-dom';
import { Feature } from 'use-feature';
import PageDataContext from '../../context/PageDataContext';
import { usePageDataCache } from '../../hooks/usePageDataCache';

export const ProfileBanner = () => {
    const { isLoadFromCache } = useContext(PageDataContext);
    const localStoragePrefix = 'ProfileBanner';

    let location = useLocation();
    const [settingsActive, setSettingsActive] = usePageDataCache(
        `${localStoragePrefix}_settingsActive`,
        '',
    );
    const [vaultActive, setVaultActive] = usePageDataCache(`${localStoragePrefix}_vaultActive`, '');
    const [membershipActive, setMembershipActive] = usePageDataCache(
        `${localStoragePrefix}_membershipActive`,
        '',
    );

    useEffect(() => {
        if (location.pathname === '/settings') {
            setVaultActive('');
            setMembershipActive('');
            setSettingsActive('active-nav-button');
        } else if (location.pathname === '/vault') {
            setVaultActive('active-nav-button');
            setMembershipActive('');
            setSettingsActive('');
        } else if (location.pathname === '/membership') {
            setVaultActive('');
            setMembershipActive('active-nav-button');
            setSettingsActive('');
        }
    }, [location]);

    return (
        <Box className={'profile-banner wrapper'}>
            <UnorderedList listStyleType="none">
                <Flex justify="space-evenly">
                    <ListItem>
                        <Link as={ReactRouterLink} to="/settings">
                            <Button id={settingsActive}>
                                <Text>Settings</Text>
                            </Button>
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link as={ReactRouterLink} to="/vault">
                            <Button id={vaultActive}>
                                <Text>My Vault</Text>
                            </Button>
                        </Link>
                    </ListItem>
                    <Feature name="FEATURE_FLAG_MEMBERSHIP">
                        <ListItem>
                            <Link as={ReactRouterLink} to="/membership">
                                <Button id={membershipActive}>
                                    <Text>Membership</Text>
                                </Button>
                            </Link>
                        </ListItem>
                    </Feature>
                </Flex>
            </UnorderedList>
        </Box>
    );
};
